module.exports = __webpack_public_path__ + "public/images/teacher.90c9c7d890aa0890a4fff2468bdc6749.jpg";